import gql from 'graphql-tag';

import RecipeTagFragment from './fragments/RecipeTag.gql';
import UserRecipeFragment from './fragments/UserRecipe';

export const GET_USER_RECIPE_BOX = gql`
  query recipeBox {
    recipeBox {
      recipeBoxId
      recipes {
        ...UserRecipeFragment
      }
      tags {
        ...RecipeTagFragment
      }
      auth0User
      updatedAt
    }
  }
  ${RecipeTagFragment}
  ${UserRecipeFragment}
`;

export const GET_USER_RECIPE_TAGS = gql`
  query recipeTags {
    recipeTags {
      ...RecipeTagFragment
    }
    ${RecipeTagFragment}
  }
`;

export const GET_USER_RECIPES = gql`
  query userRecipes($tagsIds: [ID]) {
    userRecipes(input: { tagsIds: $tagsIds }) {
      recipeId
    }
  }
`;
